import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  constructor(
    private router : Router
  ) { }

  updateRouteID(newValue: string) {
    this.router.navigate([], {
      queryParams: {id : newValue},
      queryParamsHandling: 'merge'
    });
  }
}
